import styled from 'styled-components';
import { FlexibleDiv } from '../../../styled/common';
import { Breakpoints } from '../../../styled/constants';

export const FiltersWrapper = styled(FlexibleDiv)`
  gap: 15px;

  @media (min-width: ${Breakpoints.tablet}px) {
    gap: 10px;
  }

  @media (max-width: ${({ theme }) => theme.tabletBreakpoint}) {
    width: 100%;
  }
`;
